import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AlertDialog from 'components/AlertDialog'
import { ReactComponent as ButtonLoading } from 'icons/loading2.svg'
import { FaEdit, FaTrash } from 'react-icons/fa'

import {
  Container,
  Header,
  Row,
  Column,
  SubTitle,
  InfoText,
  Button
} from './styles'

export default function CustomMessage ({
  data: customMessage,
  onEdit,
  onDelete: handleDelete
}) {
  const [showAlertDialog, setShowAlertDialog] = useState (false)
  const [deleting, setDeleting] = useState (false)
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const handleEdit = () => onEdit (customMessage)

  const deleteCustomMessage = async () => {
    setDeleting (true)
    try {
      await cutileiApi.delete (`/custom_messages/${customMessage.id}`, requestConfig)

      setDeleting (false)
      handleDelete (customMessage)
    } catch (error) {
      setDeleting (false)
      logApiError (error)
    }
  }

  const toggleAlertDialog = () => setShowAlertDialog (!showAlertDialog)

  return (
    <Container>
      <Column>
        <Header>
          <SubTitle>
            {customMessage.title}
          </SubTitle>
          <Row style={{justifySelf: 'center'}}>
            <Button onClick={handleEdit}>
              <FaEdit color='#35A7FF' size={18}/>
            </Button>
            <Button onClick={toggleAlertDialog}>
              {deleting ? (
                <ButtonLoading style={{margin: 0}}/>
              ) : (
                <FaTrash color='#FF3939' size={16}/>
              )}
            </Button>
          </Row>
        </Header>
        <InfoText style={{marginLeft: 5, whiteSpace: 'pre-line'}}>
          {customMessage.content}
        </InfoText>
      </Column>
      <AlertDialog
        visible={showAlertDialog}
        title='Atenção!'
        message='Deseja realmente excluir esta mensagem personalizada?'
        confirmText='Sim'
        cancelText='Não'
        onConfirm={deleteCustomMessage}
        onClose={toggleAlertDialog}
        dangerous={true}
      />
    </Container>
  )
}
